const fakeNamesAndEmails = [
  {
    firstName: "David",
    lastName: "N. Crowell",
    email: "davidn.crowell@dayrep.com",
    phone: "217-264-3787",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Sonny",
    lastName: "L. Hill",
    email: "sonnyl.hill@rhyta.com",
    phone: "219-384-9738",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Wade",
    lastName: "B. Landis",
    email: "wadeb.landis@rhyta.com",
    phone: "801-841-5765",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Joan",
    lastName: "J. Fisher",
    email: "joanj.fisher@teleworm.us",
    phone: "808-885-1423",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Harold",
    lastName: "B. Meyer",
    email: "haroldb.meyer@armyspy.com",
    phone: "510-352-5662",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Theresa",
    lastName: "T. Seeger",
    email: "theresat.seeger@armyspy.com",
    phone: "409-746-7471",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Georgia",
    lastName: "T. Goldman",
    email: "georgiat.goldman@armyspy.com",
    phone: "252-367-6317",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Latonya",
    lastName: "C. Frey",
    email: "latonyac.frey@dayrep.com",
    phone: "213-985-2432",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Frank",
    lastName: "C. Grimes",
    email: "frankc.grimes@armyspy.com",
    phone: "954-356-0002",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Jean",
    lastName: "P. Smith",
    email: "jeanp.smith@rhyta.com",
    phone: "716-210-1431",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Corey",
    lastName: "J. Morris",
    email: "coreyj.morris@dayrep.com",
    phone: "310-671-3216",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Toni",
    lastName: "H. Chatman",
    email: "tonih.chatman@rhyta.com",
    phone: "310-368-0070",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "George",
    lastName: "P. Adams",
    email: "georgep.adams@dayrep.com",
    phone: "517-563-9109",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Steven",
    lastName: "L. Foote",
    email: "stevenl.foote@armyspy.com",
    phone: "815-931-5985",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Larry",
    lastName: "E. Villa",
    email: "larrye.villa@dayrep.com",
    phone: "662-631-1003",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Luna",
    lastName: "Davis",
    email: "luna.davis@company.com",
    phone: "601-422-3537",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Jason",
    lastName: "S. Eaton",
    email: "jasons.eaton@teleworm.us",
    phone: "256-366-6638",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Clayton",
    lastName: "V. Marks",
    email: "claytonv.marks@jourrapide.com",
    phone: "763-572-6769",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "Luna",
    lastName: "Davis",
    email: "luna.davis@company.com",
    phone: "530-365-9556",
    avatar: "https://i.pravatar.cc/100",
  },
  {
    firstName: "John",
    lastName: "M. Moro",
    email: "johnm.moro@rhyta.com",
    phone: "863-660-8072",
    avatar: "https://i.pravatar.cc/100",
  },
];

export default fakeNamesAndEmails;
